var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/hrgs/DataSourceEnum';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getAll: `${API_URL}/api/datasources`,
    getDataReference: `${API_URL}/api/dataReferences`,
    getDataSourceEducation: `${API_URL}/api/educations`,
    getDataSourceProvince: `${API_URL}/api/provinces`,
    getDataSourceGender: `${API_URL}/api/genders`
};
let DataSourceModule = class DataSourceModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.dataReferenceList = [];
    }
    get getDataReferenceList() {
        return this.dataReferenceList;
    }
    [_a = Mutations.SET_DATA_REFERENCE](data) {
        this.dataReferenceList = data;
    }
    // *ACTIONS
    [_b = Actions.GET_LIST]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const url = `${API_URLS.getAll}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get data source list.'
                });
                reject(error);
            });
        });
    }
    [_c = Actions.GET_DATA_REFERENCE]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const url = `${API_URLS.getDataReference}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                this.context.commit(Mutations.SET_DATA_REFERENCE, resData);
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get data reference list.'
                });
                reject(error);
            });
        });
    }
    [_d = Actions.GET_EDUCATION]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const url = `${API_URLS.getDataSourceEducation}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get data source list.'
                });
                reject(error);
            });
        });
    }
    [_e = Actions.GET_PROVINCE]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const url = `${API_URLS.getDataSourceProvince}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get data source list.'
                });
                reject(error);
            });
        });
    }
    [_f = Actions.GET_GENDER]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            hrgsSwalAlert({ icon: 'error', text: 'Employee ID tidak ditemukan.' });
            return false;
        }
        const url = `${API_URLS.getDataSourceGender}/${employeeID}?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed get data source list.'
                });
                reject(error);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _a, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _b, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _d, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataSourceModule.prototype, _f, null);
DataSourceModule = __decorate([
    Module
], DataSourceModule);
export default DataSourceModule;
